// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"mb","cardContent":"mc","editButton":"md","innerHeading":"me","header":"mf","subHeader":"mh"};